<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Test it!'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="testForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Notification account'|translate}}</mat-label>
                    <mat-select formControlName="notificationAccount" required>
                        <mat-option [value]="null">

                        </mat-option>
                        <mat-option [value]="account.id" *ngFor="let account of notificationAccounts">
                            {{account.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>{{'Notification account is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Receiver'|translate}}</mat-label>
                    <input matInput formControlName="receiver" required>
                    <mat-error>{{'Receiver is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(testForm.value)"
                aria-label="Test it!">
            {{'Test it!'|translate}}
        </button>
    </div>
</div>
